import { ProjectAddressResponse } from '@/types/service-response'

export class AddressProjectAddress {
  public constructor (
    readonly adressSchritteId: number,
    readonly adressenId: number,
    readonly adressArtenId: number,
    readonly mitAdressId: number,
    readonly wertId: number,
    readonly code: string,
    readonly adressArt: string,
    readonly prozessSchrittTyp: string,
    readonly adressnummer: string,
    readonly adressLinie: string,
    readonly genAdresse: string
  ) {}

  static createFromResponse (responseData: ProjectAddressResponse[]): Array<AddressProjectAddress> {
    return responseData.map((item: ProjectAddressResponse ) => {
      return new AddressProjectAddress(
        item.AdressSchritteID,
        item.AdressenID,
        item.AdressArtenID,
        item.MitAdressID,
        item.WertID,
        item.Code,
        item.AdressArt,
        item.ProzessSchrittTyp,
        item.Adressnummer,
        item.AdressLinie,
        item.GenAdresse
      )
    })
  }
}
